import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, from, map, of } from 'rxjs';

import * as Mappers from '@shared/core/mappers/paymentProviders';

import { BaseGooglePayService } from './base-google-pay.service';

const STRIPE_VERSION = '2024-06-20';

@Injectable({
    providedIn: 'root',
})
export class StripeGooglePayService extends BaseGooglePayService {
    public pay(totalPrice: string, stripeToken: string): Observable<Nullable<OLO.DTO.GooglePayPaymentData>> {
        if (!this._instance) {
            console.error('Google Pay instance not initialized');

            return of(null);
        }

        return from(this._instance.loadPaymentData(this._generatePaymentDataRequestObj(totalPrice, stripeToken))).pipe(
            map((paymentData) => Mappers.GooglePayPaymentProviderMapper.mapDirectResponseToPayData(paymentData?.paymentMethodData)),
            catchError((err) => {
                console.error('Google pay payment error:', err);

                return of(null);
            }),
        );
    }

    protected _generatePaymentDataRequestObj(totalPrice: string, stripeToken: string): google.payments.api.PaymentDataRequest {
        return {
            ...(this._readyToPayRequest as google.payments.api.PaymentDataRequest),
            allowedPaymentMethods: this._readyToPayRequest.allowedPaymentMethods.map((paymentMethod) => ({
                ...paymentMethod,
                /* eslint-disable quote-props */
                tokenizationSpecification: {
                    type: 'PAYMENT_GATEWAY',
                    parameters: {
                        gateway: 'stripe',
                        'stripe:version': STRIPE_VERSION,
                        'stripe:publishableKey': stripeToken,
                    },
                },
                /* eslint-enable quote-props */
            })),
            transactionInfo: {
                totalPrice,
                totalPriceStatus: 'FINAL' as google.payments.api.TotalPriceStatus,
                countryCode: this._config.localization.country,
                currencyCode: this._config.localization.currency || 'AUD',
            },
            merchantInfo: {
                merchantId: this._config.payments.googlePay.gatewayMerchantId,
                merchantName: this._config.payments.googlePay.merchantName ?? null,
            },
        };
    }
}
